import { theme } from '@dasa-health/components-react'
import styled from 'styled-components'

export const StyledForm = styled.div`
    height: auto;
    flex: 1 0;
    display: flex;
    flex-direction: column;
    padding-top: 24px;
    margin-bottom: 6rem;

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        width: 434px;
        margin-bottom: 0;
    }

    p {
        margin-bottom: 1.5rem;
    }

    div.form__personal-data__field.underage {
        height: auto;
        margin-bottom: 22px;
    }

    .form__personal-data {
        & > .form__personal-data__field {
            display: inline-block;
            height: 56px;
            width: 100%;
            margin-bottom: 44px;

            & > h6 {
                margin-bottom: -20px;
            }
        }

        span {
            white-space: normal;
        }

        > label > div {
            align-self: flex-start;
        }
    }

    .form__subtitle__link {
        font-size: 14px;
        width: 100%;
    }

    form {
        display: flex;
        flex-direction: column;
        height: 100%;

        @media screen and (min-width: ${theme.breakpoints[0]}) {
            display: initial;
            height: initial;
        }
    }
`

export const FieldWithButton = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 40px;

    .form__personal-data__field {
        width: 100%;
    }
`
